<template>
    <v-alert type="success">
        Questa azione &egrave; stata completata il {{ completeDate }} alle {{ completeTime }}.
    </v-alert>
</template>

<script>
import Action from '@/models/action'

export default 
{
   name: 'ActionProviderMessageComplete',

   mixins: [],

   components: 
   {

   },

   data: () => ({
    
   }),

   props: {
    action: {
        type: Action,
        required: true
    }
   },

   computed: 
   {
    completeDate()
    {
        return this.action.completedAt.format('DD/MM/YYYY')
    },
    completeTime()
    {
        return this.action.completedAt.format('HH:mm')
    }
   },

   methods:
   {
    
   },

   mounted()
   {

   }
}
</script>